import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_3 = { style: {"width":"1000px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Search")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_input_group = _resolveComponent("n-input-group")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_dialog_provider = _resolveComponent("n-dialog-provider")!
  const _component_n_notification_provider = _resolveComponent("n-notification-provider")!
  const _component_n_message_provider = _resolveComponent("n-message-provider")!
  const _component_n_loading_bar_provider = _resolveComponent("n-loading-bar-provider")!
  const _component_n_config_provider = _resolveComponent("n-config-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_config_provider, { class: "min-h-screen" }, {
      default: _withCtx(() => [
        _createVNode(_component_n_loading_bar_provider, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_message_provider, null, {
              default: _withCtx(() => [
                _createVNode(_component_n_notification_provider, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_dialog_provider, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_n_input_group, { style: {"justify-content":"center","margin-bottom":"15px"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_n_input, {
                                  style: { width: '50%' },
                                  value: _ctx.searchTerm,
                                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
                                  placeholder: "артикул"
                                }, null, 8, ["value"]),
                                _createVNode(_component_n_button, {
                                  type: "primary",
                                  onClick: _ctx.search,
                                  ghost: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
                                return (_openBlock(), _createBlock(_component_n_card, {
                                  style: {"margin-bottom":"10px"},
                                  key: item.description
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString(item.brand), 1),
                                    _createTextVNode(" - " + _toDisplayString(item.description), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}